import { render, staticRenderFns } from "./echartBMap.vue?vue&type=template&id=b3633450"
import script from "./echartBMap.vue?vue&type=script&lang=js"
export * from "./echartBMap.vue?vue&type=script&lang=js"
import style0 from "./echartBMap.vue?vue&type=style&index=0&id=b3633450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports